import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

import DialogTitle from '@mui/material/DialogTitle'
import Dialog from '@mui/material/Dialog'
import CloseIcon from '@mui/icons-material/Close'
import { DialogActions, DialogContent, FormControl, IconButton, InputLabel, MenuItem, Select } from '@mui/material'

import './dialogApprove.css'
import iconArrowRed from './iconArrowRed.svg'
import iconCircleRed from './iconCircleRed.svg'
import iconDolarRed from './iconDolarRed.svg'

import { iniAnularPpto } from '../../../redux/actions/pptos'
import { usePptos } from '../../../hooks/usePptos'

export const DialogAnular = ({ budgetId, open, setOpen }) => {

    const dispatch = useDispatch()
    const { motivosList, initGetMotivos } = usePptos()
    const [msgError, setMsgError] = useState('')
    const [form, setForm] = useState({
        id_motivo: 0,
        nombre_motivo: ''
    })

    const handleAnular = () => {

        if (form.id_motivo === 0 || form.id_motivo === '') {
            setMsgError('Falta seleccionar motivo')
            return false
        }

        const data = {
            id: budgetId,
            id_motivo: form.id_motivo,
            nombre_motivo: form.nombre_motivo
        }

        dispatch(iniAnularPpto(data))
        setOpen(false)
    }

    const handleChange = ({ target }) => {
        const filtered = target.value !== '' ? motivosList.filter(it => it.id === target.value) : []
        setForm(prev => ({
            ...prev,
            id_motivo: target.value,
            nombre_motivo: filtered[0]?.nombre
        }))
    }

    useEffect(() => {
        initGetMotivos()
    }, [initGetMotivos])

    return (
        <Dialog onClose={() => setOpen(false)} open={open} className='p-dialog-approve'>
            <DialogTitle className='ColorTitleDocument' id="scroll-dialog-title">
                <IconButton
                    aria-label="close"
                    style={{ padding: '0', float: 'right' }}
                    onClick={() => setOpen(false)}
                >
                    <CloseIcon
                        style={{ color: '#78667E' }}
                    />
                </IconButton>
            </DialogTitle>
            <DialogContent className='content'>

                <div className='d-flex justify-content-center p-icons'>
                    <img src={iconCircleRed} alt="arrow" />
                    <img src={iconArrowRed} alt="circle" />
                    <img src={iconDolarRed} alt="dolar" />
                </div>

                <div className='text mt-3'>
                    Confirmar anulación
                </div>

                <div className='p-text-comments mt-4'>
                    <FormControl fullWidth size="small">
                        <InputLabel id="demo-simple-select-label">Motivo de anulación</InputLabel>
                        <Select
                            label="Unidad de negocio"
                            id="id_motivo"
                            name="id_motivo"
                            value={form.id_motivo || ''}
                            onChange={handleChange}
                            className='p-list-capitalize'
                        >
                            <MenuItem value='' key=''>Ninguno</MenuItem>
                            {motivosList.map(item => (
                                <MenuItem value={item.id} key={item.id} className='p-list-capitalize'>{item.nombre}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </div>

                <p className='p-text-emisor'>Esta acción dará por anulado el presupuesto</p>

                {msgError !== '' &&
                    <p style={{ color: 'red', textAlign: 'center', fontSize: '14px', marginTop: '5px' }}>{msgError}</p>
                }

            </DialogContent>
            <DialogActions className='d-flex justify-content-center mt-3 mb-2 p-actions'>
                <button className='approve' onClick={handleAnular}>Sí. Anular</button>
            </DialogActions>
        </Dialog>
    );

}